export const BaseUrl = "https://api-portal.tooledupraccoons.com/"
export const socketUrl = "https://api-portal.tooledupraccoons.com:7587/"
export const USETIFUL_TOKEN = 'f9a5be6216d0b9a6cfe74f6e4742ddb8';
export const INTERCOM_APP_ID = 'z5de9vul'
